import React, { useState } from "react";
import { Check, Crown, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const PERKS = [
  "Unlimited music & video uploads",
  "High-fidelity streaming for your fans",
  "Direct messaging with artists & fans",
  "Custom artist profile & cover banner",
  "Priority placement in Discover",
  "Verified Artist badge",
];

export default function Subscribe() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);

  const checkout = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error("Could not start checkout");
      setBusy(false);
    }
  };

  if (user.is_subscribed) {
    return (
      <div className="max-w-2xl mx-auto px-6 text-center py-16">
        <span className="inline-flex w-16 h-16 rounded-2xl bg-emerald-500/15 border border-emerald-500/40 items-center justify-center glow-emerald"><Crown className="w-8 h-8 text-emerald-400" /></span>
        <h1 className="mt-6 font-display font-extrabold text-3xl">You're an Artist Pass member 🎉</h1>
        <p className="mt-3 text-zinc-400">You have full access to uploads, messaging and pro features. Go make something.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6">
      <div className="text-center mb-8">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 font-mono-nu text-xs uppercase tracking-widest">
          <Sparkles className="w-3.5 h-3.5" /> Artist Pass
        </span>
        <h1 className="mt-4 font-display font-black text-4xl tracking-tight">Go Pro. Get Heard.</h1>
        <p className="mt-2 text-zinc-400">Everything you need to release and grow on NEXT UP.</p>
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="beam-border rounded-3xl p-8 relative overflow-hidden noise" data-testid="subscribe-card">
        <div className="flex items-baseline gap-2">
          <span className="font-display font-black text-5xl">$25</span>
          <span className="text-zinc-400 font-mono-nu">/ month</span>
        </div>
        <p className="text-sm text-zinc-500 mt-1">Cancel anytime · Billed monthly</p>

        <ul className="mt-8 space-y-3">
          {PERKS.map((p) => (
            <li key={p} className="flex items-center gap-3">
              <span className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center shrink-0"><Check className="w-3 h-3 text-emerald-400" /></span>
              <span className="text-zinc-200">{p}</span>
            </li>
          ))}
        </ul>

        <button onClick={checkout} disabled={busy} data-testid="subscribe-checkout-btn"
          className="mt-8 w-full py-4 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-black font-bold text-lg transition-colors disabled:opacity-50">
          {busy ? "Redirecting to checkout…" : "Get Artist Pass"}
        </button>
        <p className="mt-3 text-center text-xs text-zinc-500 font-mono-nu">Secure checkout via Stripe · Test card 4242 4242 4242 4242</p>
      </motion.div>
    </div>
  );
}
